module.exports = __webpack_public_path__ + "static/img/logo.1ba2cb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/CUSTOM/assets/logo.png
// module id = 485
// module chunks = 1